"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lithuaniaTranslations = void 0;
var _types = require("../../../types");
const lithuaniaTranslations = exports.lithuaniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Atsiprašome!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Atgal',
  [_types.ErrorPageTranslationKey.text]: 'Puslapis laikinai neveikia',
  [_types.ErrorPageTranslationKey.notFound]: 'Puslapis, kurio ieškote, neveikia',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Puslapis, kurį bandote pasiekti, yra apribotas ir atitiko ne visus kriterijus.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Susisiekite su Oriflame palaikymo komanda el. paštu:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Prašytas URL buvo atmestas!'
};
